module.exports = __webpack_public_path__ + "static/img/four-items.ea4fc52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/four-items.png
// module id = 5CiM
// module chunks = 1